<!--  -->
<template>
  <div>
    <div ref="main" class="link_box">
      <div class="sers">
        <div>公司：</div>
        <div>
          <el-select v-model="company_id" placeholder="请选择企微公司">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.company_name"
              :value="item.id"
            />
          </el-select>
        </div>

      </div>
      <div class="sers" style="margin-top:20px">
        <div>账户：</div>
        <div>
          <el-select v-model="account_id" placeholder="请选择企微账户">
            <el-option
              v-for="item in optionsr"
              :key="item.id"
              :label="item.account"
              :value="item.id"
            />
          </el-select>
        </div>
      </div>
      <div class="addserbox">
        <div class="sers" style="margin-top:20px">
          <div>群名：</div>
          <el-input v-model="groupname" style="width:200px" placeholder="请输入内容" />
        </div>
        <!-- <div class="sers" style="margin-top:20px;width:242px">
          <div style="flex-shrink: 0;">时间：</div>
          <el-time-picker
            v-model="time"
            format="HH:mm"
            value-format="HH:mm"
            placeholder="任意时间点"
            :clearable="false"
          />
        </div> -->
        <div class="sers" style="margin-top:20px">
          <div>消息：</div>
          <el-input v-model="message" style="width:200px" type="textarea" placeholder="请输入内容" />
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" class="dialog-btn" @click="sunbit">确 定</el-button>
    </span>
  </div>
</template>

<script>
import { wechatcompanying, wechatcompanyingaccount, wechatcomupwechatgroup } from '@/api/providerAccountManagement/servicePorviderList1.js'
export default {
  components: {},
  props: {
    // options: {
    //   type: Array,
    //   default: null
    // },

    // optionsr: {
    //   type: Array,
    //   default: null
    // }

  },
  data() {
    return {
      company_id: null,
      account_id: null,
      include_status: null,
      options: [],
      optionsr: [],
      groupname: '',
      message: '',
      time: '',
      id: null
    }
  },
  // watch: {
  //   options: {
  //     handler(newVal) {
  //       console.log('xxx1', newVal)
  //       this.rwoptions = newVal
  //     },
  //     immediate: true
  //   },
  //   optionsr: {
  //     handler(newVal) {
  //       console.log('xxx1', newVal)
  //       this.rwoptionsr = newVal
  //     },
  //     immediate: true
  //   }

  // },
  created() {

  },
  mounted() {

  },
  methods: {
    async adddata() {
      const data = await wechatcompanying()
      this.options = data.data.list
      console.log('data', data)
    },
    async adddatatwo() {
      const data = await wechatcompanyingaccount()
      this.optionsr = data.data.list
      console.log('data', data)
    },
    resback(item) {
      this.adddata()
      this.adddatatwo()
      console.log('item', item)
      this.company_id = item.company_id
      this.account_id = item.account_id
      this.groupname = item.group_name
      this.message = item.message
      this.include_status = item.include_status
      // this.time = item.timeHi
      this.time = '10:30'
      this.id = item.id
    },

    async sunbit() {
      if (this.groupname === '') {
        this.$message.error('请填写群组名')
        return
      }
      if (this.message === '') {
        this.$message.error('请填写消息')
        return
      }
      const data = await wechatcomupwechatgroup(this.id, this.account_id, this.company_id, this.groupname, this.message, this.time, this.include_status)
      // const data = await wechatcomupwechatgroup(id, account_id, company_id, group_name, message, timeHi, strs)
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.$emit('updata')
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sers{
  display: flex;
  align-items: center;
}
.addserbox{
  /* display: flex;
  align-items: center; */
  margin-top: 10px;
}
.dialog-btn{
    margin-top: 30px;
    margin-left: 260px;
}
</style>
